document.addEventListener('DOMContentLoaded', function load() {
  
  
  	 var pw_button = $("#pw_cart_button");
     var staticProduct = $("#pw_static_product");
  
     if ($(".product.product--small").length && (pw_button.length || staticProduct.length) ){
        setTimeout(function(){ 
       		$(".shopify-payment-button").hide();
         },1000);
       
       $(document).on("change", ".selector-wrapper select", function(e){
       	$(".shopify-payment-button").hide();
       });
     }

    if($(".product.product--small").length && pw_button.length){

      $("body").addClass("pw-product");
        
      function personaliseButton(){

        $("body").on('DOMSubtreeModified', "#pw_personalisation_id", function() {

          var pw_button_text = $("#pw_cart_button").val();
          if(pw_button_text == "Personalise"){
            $('#pw_cart_button').val('Edit');
            setTimeout(function(){ 
              $(".pwAddToCart").show();
            },1000);
          } 

        });


        // Select the node that will be observed for mutations
        var targetNode = document.getElementById('pw_personalisation_id');

        // Options for the observer (which mutations to observe)
        var config = { attributes: true, childList: true };

        // Callback function to execute when mutations are observed
        var callback = function(mutationsList) {
          //for(var mutation of mutationsList) {
          for(var mutation in mutationsList) {

            var pw_button_text = $("#pw_cart_button").val();
            if(pw_button_text == "Personalise"){
              $('#pw_cart_button').val('Edit');
              setTimeout(function(){ 
                $(".pwAddToCart").show();
              },1000);
            }
          }

        };

        // Create an observer instance linked to the callback function
        var observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);

        var pw_button = $("#pw_cart_button");
        if (typeof pw_button  !== "undefined"){
          setTimeout(function(){
            $(".shopify-payment-button, .pwAddToCart").hide();
          },3000);

        }
      }

      personaliseButton();


      function pwVariationChange(){
       
       

        var pw_cart_button = $("#pw_cart_button").html();
        if (typeof  pw_cart_button !== 'undefined'){
          var pw_button_text = $("#pw_cart_button").val();
          if(pw_button_text == "Edit"){
			            
            var product_image_original = $('meta[property="og:image"]').attr('content');
			
            setTimeout(function(){ 
    
              $(".product__media-item.is-active img.image-magnify-lightbox").attr("data-src", product_image_original);
              $(".product__media-item.is-active img.image-magnify-lightbox").attr("data-bgset", product_image_original);
              $(".product__media-item.is-active img.image-magnify-lightbox").attr("src", product_image_original);
              $(".product__media-item.is-active img.image-magnify-lightbox").attr("srcset", product_image_original);

            }, 500);
           
            if (document.documentMode || /Edge/.test(navigator.userAgent)) {
              $("#pw_cart_button").prop('value', 'Personalise');
            } else{
              $('#pw_cart_button').val('Personalise');
            }


            
          }
          
          setTimeout(function(){ 
              $(".shopify-payment-button, .pwAddToCart").hide();
             
           },500);
        }

      }
      $("fieldset.product-form__input input").on("click", function(e){
		  
         pwVariationChange();

         setTimeout(function(){ 
            var original_variant_id = $(".original-variant-id").val();
            
            $('.pwProductSelect option:selected').removeAttr('selected');
            $('.pwProductSelect option[value="'+original_variant_id+'"]').attr("selected","selected");
            
        },500);

      });

      $(".pwAddToCart").on("click", function(e){
		setTimeout(function(){ 
         replaceSmallImage();
        },1500);

      });

      
  	function replaceSmallImage(){
  
      var cardID = $("#pw_personalisation_id").val();
      
        var rand = Math.floor(Math.random() * 10000);
        var newSrc = "https://pwcdn.net/thumbnails/563/"+cardID+".jpg?r="+rand;

        $("#cart-notification #cart-notification-product .cart-notification-product__image img").attr("src",newSrc);
        $("#cart-notification #cart-notification-product .cart-notification-product__image img").attr("srcset",newSrc);
      
    }
      
    }
}, false);

